import {
  CostCentersValueObjectsProcessingStatusEnum,
  CostCentersValueObjectsStructureEnum,
  JobCatalogEnumsJobCatalogTreeNodeTypesEnum,
} from 'generated/resources/graphql'

export interface TreeNode {
  [key: string]: unknown // Required to satisfy RecordType constraint for OneDataCollection
  id: number
  node_uuid: string
  type: JobCatalogEnumsJobCatalogTreeNodeTypesEnum
  ancestor_id: string | null
  name: string
  description: string | null
  children: TreeNode[]
  parent?: TreeNode
}

export const Hierarchy: JobCatalogEnumsJobCatalogTreeNodeTypesEnum[] = [
  'jobcatalog_treefamily',
  'jobcatalog_treefunction',
  'jobcatalog_treerole',
]

export const PendingStatuses: CostCentersValueObjectsProcessingStatusEnum[] = [
  'pending',
  'processing',
]

export const JobCatalogStructureMapping: Partial<
  Record<JobCatalogEnumsJobCatalogTreeNodeTypesEnum, CostCentersValueObjectsStructureEnum>
> = {
  jobcatalog_treefamily: 'job_catalog_family',
  jobcatalog_treefunction: 'job_catalog_function',
  jobcatalog_treerole: 'job_catalog_role',
}

export interface Workplace {
  id: number
  name: string
}

export interface PreviewRow {
  [key: string]: unknown // Required to satisfy RecordType constraint for OneDataCollection
  id: string
  name: string
  familyName?: string
  functionName?: string
  roleName?: string
  workplaceName?: string
}
